/**
 * 一键快撤
 * created by: llh
 */
'use strict';
angular.module("manageSysOneKeyWithdrawLogModule", [])
    .controller("manageSysOneKeyWithdrawLogCtrl", ['$scope', 'trsHttpService', '$q', '$stateParams', '$state', 'modalDialog', 'localStorageService',
        function($scope, trsHttpService, $q, $stateParams, $state, modalDialog, localStorageService) {
            initStatus();
            initData();

            function initStatus() {
                $scope.status = {
                    keywords: '',
                };

                $scope.data = {
                    items: [],
                    selectedArray: [],
                };
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 20,
                    PAGECOUNT: 0,
                    ITEMCOUNT: 0,
                    copyCurrPage: 1,
                };
                
            }

            function initData() {
                // $scope.data.items = $scope.fake.DATA;
                // $scope.page.ITEMCOUNT = $scope.fake.PAGER.ITEMCOUNT;
                // $scope.page.PAGECOUNT = $scope.fake.PAGER.PAGECOUNT;
                getLogList();
            }

            function getLogList(){
                var logParams = {
                    serviceid: 'mlf_withdrawdoc',
                    methodname: 'queryWithdrawLogs',
                    BeginDate: $scope.data.fromdate ? $scope.data.fromdate + ' 00:00:00' : '',
                    EndDate: $scope.data.untildate ? $scope.data.untildate + ' 23:59:59' : '',
                    Keyword: $scope.status.keywords,
                    PageSize: $scope.page.PAGESIZE,
                    PageIndex: $scope.page.CURRPAGE,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(),logParams,'get').then(function(data){
                    $scope.data.items = data.DATA;
                    $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                    $scope.page.PAGESIZE = data.PAGER.PAGESIZE;
                })
            }
            $scope.search = function(){
                getLogList();
            }
            /**
             * [selectPageNum description] 选择一页要显示的数据量
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function() {
                $scope.page.copyCurrPage = 1;
                getLogList();
            };
            /**
             * [pageChanged description] 下一页 页面改变调取数据
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                $scope.page.copyCurrPage = $scope.page.CURRPAGE;
                getLogList();
                // console.log($scope.data.docIdNot);
            };
            /**
             * [jumpToPage description] 跳转页
             * @return {[type]} [description]
             */
            $scope.jumpToPage = function() {
                if ($scope.page.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.page.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.page.CURRPAGE = $scope.page.copyCurrPage;
                getLogList();
            };
            /**
             * [setCheck 查看]
             * @param {[type]} item [description]
             */
            $scope.setCheck = function(item) {
                localStorageService.set('oneKeyWithdrawLogItem', JSON.stringify(item));
            };
            
        }
    ]);